/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateReceiptDto } from '../../models/create-receipt-dto';
import { ReceiptDto } from '../../models/receipt-dto';

export interface ReceiptControllerCreateNoScheduleReceipt$Params {

/**
 * 센터 ID
 */
  centerId: string;
      body: CreateReceiptDto
}

export function receiptControllerCreateNoScheduleReceipt(http: HttpClient, rootUrl: string, params: ReceiptControllerCreateNoScheduleReceipt$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
  const rb = new RequestBuilder(rootUrl, receiptControllerCreateNoScheduleReceipt.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReceiptDto>;
    })
  );
}

receiptControllerCreateNoScheduleReceipt.PATH = '/api/receipt/normal';
